import { Component, OnInit } from '@angular/core';
import { SupplierService } from '../services/supplier.service';
import { ActivatedRoute, Router } from '@angular/router';
import { WizardService } from 'src/app/shared/service/wizard.service';
import { Page } from '../../../shared/model/page';
import { Task } from '../../account/models/Task';
import { TaskFilterForm } from '../../shared/models/TaskFilterForm';
import { TaskService } from '../../../shared/service/task.service';
import { AddressService } from '../../shared/services/address.service';
import { CountyDTO } from '../../shared/models/CountyDTO';
import { CityDTO } from '../../shared/models/CityDTO';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { KeyValue } from '@angular/common';

export enum TaskTypeEnum {
  ALL = 'ALL',
  ContractNetworkChangedInfo = 'Actualizare date serviciu de retea - schimbare furnizor',
  ContractNetworkChangedInfoCCS = 'Actualizare date serviciu de retea - incetare contract furnizare'
}

@Component({
  selector: 'app-task-supplier',
  templateUrl: './task-supplier.component.html',
  styleUrls: ['./task-supplier.component.scss']
})
export class TaskSupplierComponent implements OnInit {

  public tasks: Page<Task>;
  paginationTasks = [];
  taskFilterForm: TaskFilterForm = new TaskFilterForm();
  public taskForm: FormGroup;
  public counties: CountyDTO[] = [];
  public cities: CityDTO[] = [];
  public statusOptions: string[];
  private formSubscriptions: Subscription[] = [];

  public taskDisplaySettings = {
    actions: {
      custom: [
        {
          name: 'takeTask',
          title: '<p class="actionPT">Preia task</p>'
        },
        {
          name: 'resolveTask',
          title: '<p class="actionRT">Rezolva task</p>'
        },

        {
          name: 'viewDetails',
          title: '<p class="actionVD">Vezi detalii</p>'
        }
      ],
      add: false,
      edit: false,
      delete: false,
      position: 'right',
      columnTitle: 'Opțiuni',
    },
    rowClassFunction: (row) => {

      if (row.data.status == 'FINALIZED') { //UNASSIGNED // ASSIGNED
        return 'row_finalized';
      } else if (row.data.status == 'UNASSIGNED') {
        return 'row_unassigned';
      } else if (row.data.status == 'ASSIGNED') {
        return 'row_assigned';
      } else {
        return ''
      }
    },
    hideSubHeader: true,
    columns: {
      number: {
        title: 'Numar'
      },
      task: {
        title: 'Task'
      },
      clientName: {
        title: 'Client'
      },

      placeCode: {
        title: 'POD/CLC'
      },
      address: {
        title: 'Adresa'
      },
      taskDate: {
        title: 'Data primire',
        valuePrepareFunction: (value) => value ? new Date(value).toLocaleDateString("ro-RO") : ''
      },
      status: {
        title: 'Status'
      },
      statusDate: {
        title: 'Data status',
        valuePrepareFunction: (value) => value ? new Date(value).toLocaleDateString("ro-RO") : ''
      },
      assignee: {
        title: 'Responsabil alocat',
        valuePrepareFunction: (value) => value ? value : '-'
      },
    },
  };

  public originalOrder = (a: KeyValue<string, string>, b: KeyValue<string, string>): number => {
    return 0;
  }
  constructor(
    private supplierService: SupplierService,
    private taskService: TaskService,
    private router: Router,
    private route: ActivatedRoute,
    private wizardService: WizardService,
    private formBuilder: FormBuilder,
    private addressService: AddressService,
  ) {
    this.statusOptions = ['ALL', 'ASSIGNED', 'UNASSIGNED', 'FINALIZED'];
    this.taskForm = this.formBuilder.group({
      status: [''],
      number: [''],
      type: [''],
      code: [''],
      city: [''],
      county: [''],
      receiveDate: [''],
    });
    this.formSubscriptions.push(
      this.taskForm.get('status').valueChanges.subscribe(value => this.taskFilterForm.status = value)
    );
    this.formSubscriptions.push(
      this.taskForm.get('number').valueChanges.subscribe(value => this.taskFilterForm.number = value)
    );
    this.formSubscriptions.push(
      this.taskForm.get('type').valueChanges.subscribe(value => this.taskFilterForm.type = value)
    );
    this.formSubscriptions.push(
      this.taskForm.get('code').valueChanges.subscribe(value => this.taskFilterForm.code = value)
    );
    this.formSubscriptions.push(
      this.taskForm.get('city').valueChanges.subscribe(value => this.taskFilterForm.city = value)
    );
    this.formSubscriptions.push(
      this.taskForm.get('county').valueChanges.subscribe(value => this.taskFilterForm.county = value)
    );
    this.formSubscriptions.push(
      this.taskForm.get('receiveDate').valueChanges.subscribe(value => this.taskFilterForm.receiveDate = value)
    );
  }

  ngOnInit(): void {
    this.addressService.getCounties().subscribe(data => this.counties = data);
    this.taskForm.get('status').setValue('ASSIGNED');
    this.taskForm.get('type').setValue('ALL');
    this.taskFilterForm.status = 'ASSIGNED';
    this.taskFilterForm.type = 'ALL';
    this.searchTasks();
  }

  onCustomActionTasks(event: any): void {
    console.log(event);
    switch (event.action) {
      case 'takeTask': {
        this.supplierService.assignSupplierTask(event.data.number).subscribe(() => {
          this.goToTask(event.data, true);
        });
        break;
      }
      case 'resolveTask': {
        this.goToTask(event.data, true);
        break;
      }
      case 'viewDetails': {
        this.goToTask(event.data, false);
        break;
      }
    }
  }

  goToTask(task: any, editable: boolean): void {
    console.log(task);
    switch (task.type) {
      case 'ValidareContFurnizor': {
        this.router.navigate(['..', 'date-identificare'], { relativeTo: this.route, state: { taskId: task.number, editable } });
        break;
      }
      case 'ContractSignedByClient':
      case 'ContractSignedBySupplier': {
        this.wizardService.setWizardInformation({
          taskId: task.number,
          editable: false,
          supplierContractEditable: editable,
        });
        this.router.navigateByUrl('/operator/schimba-furnizor');
        break;

        this.router.navigate(['contract-furnizare'], { relativeTo: this.route, state: { taskId: task.number, editable } });
        break;

      }
    }
  }

  searchTasks(offset?: number): void {
    this.taskFilterForm.pageOffset = offset;
    this.taskService.getSupplierTasks(this.taskFilterForm).subscribe((val) => {
      this.tasks = val;
      this.taskFilterForm.pageOffset = val.number;
      this.paginationTasks = [{ pageNumber: val.number, className: 'page-item active' }];
    });
  }

  changePage(page: any): void {
    let pageOffset = page.pageNumber;
    this.searchTasks(pageOffset);
  }

  previousPage(): void {
    let pageOffset = this.taskFilterForm.pageOffset === 0 ? 0 : this.taskFilterForm.pageOffset - 1;
    this.searchTasks(pageOffset);
  }

  nextPage(): void {
    let pageOffset = this.taskFilterForm.pageOffset === this.tasks.totalPages - 1
      ? this.taskFilterForm.pageOffset : this.taskFilterForm.pageOffset + 1;
    this.searchTasks(pageOffset);
  }

  onChangeCounty(): void {
    this.cities = [];
    this.addressService.getCities(this.taskForm.get('county').value).subscribe((cities: CityDTO[]) => this.cities = cities);
  }

  get taskTypeOptions(): typeof TaskTypeEnum {
    return TaskTypeEnum;
  }
}
